// +----------------------------------------------------------------------
// | ThisAdmin [ ThisAdmin赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2022 https://www.thisadmin.cn All rights reserved.
// +----------------------------------------------------------------------
// | Licensed ThisAdmin并不是自由软件，未经许可不能去掉ThisAdmin相关版权
// +----------------------------------------------------------------------
// | Author: ThisAdmin Team   Email: oszzw@qq.com
// +----------------------------------------------------------------------

import {createRouter, createWebHistory} from 'vue-router'
//import {getToken} from "../utils/auth";
// 路由数据
import routes from './routes';
//应用配置
import siteInfo from '/siteInfo';

//console.log(siteInfo)
//console.log(routes)

const router = createRouter({
  history: createWebHistory('/'+siteInfo.site_dist),
  routes,
  /*scrollBehavior (to, from, savedPosition) {
    console.log(to+'；'+from+'；'+savedPosition);
    return { x: 0, y: 0 }
  }*/
})
/*全局的前置钩子函数，路由切换开始时调用 监听路由变化*/
router.beforeEach((to, from, next) => {
  console.log('请求来源路径：', to+";"+from);
  //获取登录
  //let token = getToken();
  //console.log('token：', token);
  //已登录
  /*if (token && to.path == '/login') {
    next('/');
  } else if (!token && to.path != '/login' && to.path != '/license' ) {
    next('/login')
  } else {
    next();
  }*/

  next();
})
/*全局后置钩子函数，路由切换成功进入激活阶段*/
router.afterEach(to => {
  // 页面标题
  window.document.title = to.meta.title + ' - ikeyhub咋办';
  // 滚动到页面顶部
  window.scrollTo(0, 0);
});

export default router
